import React, { useCallback, useState } from 'react';
//components
import EndColumnsContainer from 'refactored/features/emergencies/ui/containers/end-columns-container';
import StartColumnsContainer from 'refactored/features/emergencies/ui/containers/start-columns-container';
import BodyRow from 'refactored/features/emergencies/ui/rows/body-row';
import { LocationsColumn } from '../columns/locations-column';
import LoadColumn from '../columns/load-column';
import ServiceTypeColumn from '../columns/service-type-column';
import { TicketColumn } from '../columns/ticket-column';
import { OwnerAgentColumn } from '../columns/owner-agent-column';
import { QuoteColumn } from '../columns/quote-column';
import RowOptionsButton from 'refactored/features/emergencies/ui/rows/row-options-button';
import RowOptionsContainer from 'refactored/features/emergencies/ui/rows/row-options-conatiner';
import RowOptionsEntries from 'refactored/features/emergencies/ui/rows/row-options-entry';
import { STATES } from 'refactored/features/emergencies/constants';

const TicketsListTableTicketRow = ({ ticket, reset, t }) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  const hasQuote = !!ticket.quote;
  const ticketState = ticket.synthetic_state;
  const isQuoteRejected = hasQuote && [STATES.REJECTED].includes(ticketState);

  const toggleOptions = useCallback(() => {
    setIsOptionsOpen(!isOptionsOpen);
  }, [isOptionsOpen, setIsOptionsOpen]);

  const closeOptions = useCallback(() => {
    if (isOptionsOpen) {
      setIsOptionsOpen(!isOptionsOpen);
    }
  }, [isOptionsOpen, setIsOptionsOpen]);

  return (
    <>
      <BodyRow key={ticket.id} disabled={isQuoteRejected}>
        <StartColumnsContainer>
          <TicketColumn ticket={ticket} />
          <LocationsColumn ticket={ticket} />
          <ServiceTypeColumn ticket={ticket} />
          <LoadColumn ticket={ticket} />
          <QuoteColumn ticket={ticket} />
        </StartColumnsContainer>
        <EndColumnsContainer>
          <OwnerAgentColumn ticket={ticket} reset={reset}></OwnerAgentColumn>
          <RowOptionsButton onClick={toggleOptions} isOpened={isOptionsOpen} />
          <RowOptionsContainer isVisible={isOptionsOpen}>
            <RowOptionsEntries onClose={closeOptions} ticket={ticket} />
          </RowOptionsContainer>
        </EndColumnsContainer>
      </BodyRow>
    </>
  );
};

export default TicketsListTableTicketRow;
